import type { MotionProps } from '@/app/components/Motion';
import Motion from '@/app/components/Motion';

import AppUIImage, { type AppUIImageProps } from './AppUIImage';
import type { AppUILottieProps } from './AppUILottie';
import AppUILottie from './AppUILottie';

export interface SecondaryAppUIProps {
  readonly activeIndex: number;
  readonly imageData?: AppUIImageProps;
  readonly index: number;
  readonly lottieData?: AppUILottieProps;
}

export const getMotionProps = ({
  isActive,
}: {
  isActive: boolean;
}): MotionProps => {
  return {
    animate: {
      opacity: isActive ? 1 : 0,
      y: isActive ? 0 : -50,
      transitionEnd: {
        opacity: isActive ? 1 : 0,
        y: isActive ? 0 : 50,
      },
    },
    initial: {
      opacity: 0,
      y: 50,
    },
    transition: {
      duration: 0.5,
    },
  };
};

const SecondaryAppUI = ({
  activeIndex,
  imageData,
  index,
  lottieData,
}: SecondaryAppUIProps) => {
  const isActive = activeIndex === index;
  const motionProps = getMotionProps({ isActive });

  return (
    <Motion
      {...motionProps}
      className="absolute bottom-0 w-full rounded-md bg-[rgba(144,144,144,0.3)] backdrop-blur-md"
    >
      {imageData && <AppUIImage {...imageData} />}
      {lottieData && <AppUILottie {...lottieData} shouldPlay={isActive} />}
    </Motion>
  );
};

export default SecondaryAppUI;
